import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { DBFile } from "@/classes";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["upload"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const loading = ref(false);
const upload = async (fileObject: File | File[]) => {
  loading.value = true;
  if (Array.isArray(fileObject)) {
    const file: DBFile = await DBFile.uploadFile(fileObject[0]);
    emit("upload", file);
  } else {
    const file: DBFile = await DBFile.uploadFile(fileObject);
    emit("upload", file);
  }
  loading.value = false;
};
const clear = () => {
  emit("upload", null);
};

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createBlock(_component_v_file_input, _mergeProps({
    disabled: loading.value || __props.disabled
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (upload($event))),
    "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (clear()))
  }), null, 16, ["disabled"]))
}
}

})